import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button } from 'wix-style-react';

export default function PlaceOrderButton({ t, placeOrder, payments, isWaitingForResponseFromServer, fullWidth }) {
  const disabled = _.isEmpty(payments) || isWaitingForResponseFromServer;
  return (
    <Button
      onClick={() => placeOrder()}
      size="large"
      dataHook="place-order-button"
      disabled={disabled}
      fullWidth={fullWidth}
    >
      {t('phoneordering_checkout_order_cta')}
    </Button>
  );
}

PlaceOrderButton.displayName = 'SubmitOrderButton';
PlaceOrderButton.propTypes = {
  t: PropTypes.func,
  placeOrder: PropTypes.func,
  payments: PropTypes.array,
  isWaitingForResponseFromServer: PropTypes.bool,
  fullWidth: PropTypes.bool,
};
